import CorrespondenceAddressResourceModel from '../../generated/types/model/resource/CorrespondenceAddressResourceModel';

export default class CorrespondenceAddressResourceViewModel extends CorrespondenceAddressResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
